/**
 * Reports page
 *
 * @author Agbonaye Osaru - osaru@sarutech.com
 */
import { Component, Input, ViewChild, ElementRef, ViewEncapsulation } from '@angular/core';
import { ToastController, LoadingController, ModalController, MenuController, NavController, Platform, AlertController, NavParams } from '@ionic/angular';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { PouchService } from '../services/pouch-service';
import { ChartService } from '../services/chart';
import { Functions } from '../services/functions';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
declare var require: any;
var moment = require('moment');
declare let zingchart: any;

@Component({
  selector: 'page-reports',
  templateUrl: 'reports.html',
  styleUrls: ['reports.scss'],
  providers: [NavParams],
  encapsulation: ViewEncapsulation.None,
})
export class ReportsPage {
  navParams = {};
  baseChart: any;
  @ViewChild('baseCanvas') baseCanvas;
  @Input() ispage: boolean = true;
  @Input() mode = '';
  @Input() filter = 'ALL';
  @Input() chartlist = [];
  yaxis = [];
  range_list = ['tax'];
  date_range = {
    from: moment().startOf('month').format('YYYY-MM-DDTHH:mm'),
    to: moment().endOf('month').format('YYYY-MM-DDTHH:mm'),
  };
  ischartdrawn = false;
  file: any = {
    id: '',
    columns: [],
  };
  tabs = {
    files: false,
    options: true,
    save: false,
  };
  loading: any;
  chartconfig = {
    type: 'separate',
    ymin0: false,
    cbat: 4,
    month: 'Off',
  };
  zchart: any;
  p: any;
  type = 'file';
  hrshift = false;
  minshift = false;
  enablesave = false;
  @Input() options: any = {
    filename: '',
    charttype: 'bar',
    xaxis: 'date',
    columns: ['amount'],
    columns_s: ['amount'],
    scale: 'scaleX,scaleY',
    multiplier: 1,
    summary: true,
    summarytype: 'date',
    summaryvalue: 'sum',
    fontsize: 20,
    fontcolor: '#505050',
    scaleYlabel: '',
    scaleY2label: '',
    preview: false,
    ymin: 'auto',
    ymax: null,
    datetime: true,
    month: this.db.demo ? -1 : new Date().getMonth(),
    year: new Date().getFullYear(),
    col: true,
    lineWidth: 2,
    mode: '',
    currency: this.db.gsetting.currency,
  };
  entitys = [];
  settings = [];
  products = [];
  years = [];
  item: any = null;
  setting;
  product;
  service;
  services = [];
  profit: any;
  showcurrency = false;
  subscriptions: any = {};
  totalSalesTax = 0;
  totalPurchaseTax = 0;
  taxableProfit = 0;
  taxOwed = 0;
  totalSalesAmount = 0;
  totalPurchaseAmount = 0;
  totalIncomeAmount = 0;
  totalExpenseAmount = 0;

  constructor(public navParams2: NavParams, private titleService: Title, public modalCtrl: ModalController, public func: Functions, public chartservice: ChartService, public loadingCtrl: LoadingController, public toastController: ToastController, public http: HttpClient, public navCtrl: NavController, public db: PouchService, private router: Router, public alertCtrl: AlertController) {
    this.navParams = this.router.getCurrentNavigation() && this.router.getCurrentNavigation().extras.state != undefined ? this.router.getCurrentNavigation().extras.state : this.navParams2.data;
    this.titleService.setTitle(`Reports - ${this.db.gsetting.username} - ${this.db.appinfo.title}`);
    this.zchart = this.chartservice.zchart;
    this.zchart.data.series = [];
  }

  initOthers() {
    if (this.db.appinfo.base_product == 'billing') {
      this.options.mode = 'income';
    } else if (this.db.appinfo.base_product == 'pos' || this.db.appinfo.base_product == 'inventory' || this.db.appinfo.base_product == 'pharmacy') {
      this.options.mode = 'sale';
    } else if (this.db.appinfo.base_product == 'maintenance') {
      this.options.mode = 'maintenance_record';
    } else if (this.db.appinfo.base_product == 'prescription') {
      this.options.mode = 'prescription';
    } else if (this.db.appinfo.base_product == 'patient' || this.db.appinfo.base_product == 'ward' || this.db.appinfo.base_product == 'hospital') {
      this.options.mode = 'visit';
    } else if (this.db.appinfo.base_product == 'rota') {
      this.options.mode = 'schedule';
    } else if (this.db.appinfo.base_product == 'tailor' || this.db.appinfo.base_product == 'garage') {
      this.options.mode = 'job';
    }
    this.loadData(false);
  }

  ngOnInit() {
    //set option  mode
    if (this.navParams != undefined && this.navParams['mode'] != undefined) {
      this.options.mode = this.navParams['mode'];
    } else if (!this.ispage && this.db.gsetting.chartoptions != undefined) {
      //load saved chart options from database if its not a component
      this.options = this.db.gsetting.chartoptions;
    }
    if (this.navParams != undefined && this.navParams['entity'] != undefined) {
      this.product = this.navParams['entity'];
      this.options.filename = this.product.name;
    }
    this.db.getAll('setting').then((settings) => {
      this.settings = settings
        .filter((setting) => !setting.child && (setting.date != undefined || setting.id == 'product' || setting.id == 'service' || setting.start != undefined))
        .slice()
        .reverse();
      this.settings.map((setting) => {
        let item: any = {
          id: setting.id,
          name: setting._name || this.db.rename(setting.id, this.db.language, 'title'),
          mode: setting.id == 'product' ? 'sale' : setting.id == 'service' ? 'income' : setting.id,
          count: '',
        };
        setting.keys.map((key) => {
          if (setting[key].type == 'select') {
            if (item.filters == undefined) {
              item.filters = [];
            }
            item.filters.push({
              name: key,
              options: setting[key].options || [],
              value: '',
              type: 'select',
            });
          } else if (key == 'timeline' && setting['status'] != undefined) {
            item.type = 'timeline';
            item.options = setting.status.options || [];
            item.from = '';
            item.to = '';
          }
        });
        this.chartlist.push(item);
        if (setting.id == 'sale') {
          this.chartlist.push({
            id: 'profit',
            name: 'Profit and Loss',
            mode: 'sale',
          });
          this.chartlist.push({
            id: 'tax',
            name: 'Tax Report',
          });
        }
        if (setting.id == 'laboratoryrequest' || setting.id == 'radiologyrequest') {
          this.chartlist.push({
            id: `${setting.id}_turn_around_time`,
            name: `${this.db.rename(setting.id, this.db.language, 'title')} Turn Around Time`,
            mode: setting.id,
            type: 'range',
            fields: ['date', 'date_completed'],
            label: 'Hours',
          });
        }
        if (setting.id == 'radiologyrequest') {
          this.chartlist.push({
            id: `${setting.id}_turn_around_time`,
            name: `${this.db.rename(setting.id, this.db.language, 'title')} Reporting Time`,
            mode: setting.id,
            type: 'range',
            fields: ['examination_date', 'date_completed'],
            label: 'Hours',
          });
        }
        if (setting.id == 'product' || setting.id == 'service') {
          this.subscriptions[setting.id] = this.db.getAllRx(setting.id).subscribe((items) => {
            this[`${setting.id}s`] = items;
          });
        }
      });
      this.initOthers();
    });
    this.loadYears();
  }

  saveOptions() {
    this.db.gsetting.chartoptions = this.options;
    this.db.update(this.db.gsetting, 'setting').then((res) => {
      this.presentToast('Chart Options Saved Successfully');
    });
  }

  ionViewWillLeave() {
    let subscriptions = Object.keys(this.subscriptions);
    subscriptions.map((subscription) => {
      this.subscriptions[subscription].unsubscribe();
    });
  }

  async loadData(clear = true) {
    this.item = this.chartlist.find((item) => item.id == this.options.mode);
    if (this.item?.id == 'profit') {
      this.entitys = [];
      await this.profitAndTax('profit');
    } else {
      this.loadEntitys(clear);
    }
  }

  loadEntitys(clear) {
    this.zchart.data.total = 0;
    this.entitys = [];
    this.subscriptions[this.item.mode] = this.db.getAllRx(this.item.mode).subscribe((results) => {
      results = results.sort(function (a, b) {
        return new Date(a.date || a.start).getTime() - new Date(b.date || b.start).getTime();
      });
      if ((this.item.id == 'product' || this.item.id == 'service') && this.item[this.item.id]) {
        results.map((entity) => {
          if (entity.items != undefined) {
            entity.items.map((item) => {
              if (item.id == this.item[this.item.id].id) {
                item.date = entity.date;
                this.entitys.push(item);
              }
            });
          }
        });
      } else if (this.item.type == 'range') {
        results.map((result) => {
          if (result[this.item.fields[0]] != undefined) {
            if (result[this.item.fields[1]] == undefined) {
              result[this.item.fields[1]] = new Date();
            }
            let entity = {
              date: result[this.item.fields[1]],
              hours: Math.abs(new Date(result[this.item.fields[1]]).getTime() - new Date(result[this.item.fields[0]]).getTime()) / (60 * 60 * 1000),
            };
            this.entitys.push(entity);
          }
        });
        this.options.scaleYlabel = this.item.label || 'Hours';
        this.options.summaryvalue = 'avg'; //use average value
      } else if (this.item.type == 'timeline' && this.item.from && this.item.to) {
        results.map((result) => {
          let from = result.timeline ? result.timeline.find((item) => item.status == this.item.from) : null;
          let to = result.timeline ? result.timeline.find((item) => item.status == this.item.to) : null;
          if (from && to) {
            let entity = {
              date: result.date,
              hours: Math.abs(new Date(to.date).getTime() - new Date(from.date).getTime()) / (60 * 60 * 1000),
            };
            this.entitys.push(entity);
          }
        });
        this.options.scaleYlabel = this.item.label || 'Hours';
        this.options.summaryvalue = 'avg'; //use average value
        this.options.filename = `${this.item.from} to ${this.item.to} (Hours)`;
      } else if (this.item.filters != undefined && this.item.filters.length > 0) {
        this.item.filters.map((filter) => {
          if (filter.value != '') {
            results = results.filter((result) => result[filter.name] == filter.value);
          }
        });
        this.entitys = results;
        this.options.filename = '';
      } else {
        this.entitys = results;
        //this.options.filename = '';
      }
      this.drawchart(clear);
    });
  }

  selectEntity(item, type) {
    if (!this.item[type]) {
      this.zchart.data.series.pop();
    }
    this.item[type] = item;
    this.options.filename = item.name;
    //this.loadEntitys(false);
  }

  loadYears() {
    this.setting = this.db.gsetting;
    let start = new Date(this.setting.startdate).getFullYear();
    let end = new Date().getFullYear();
    for (var i = end; i > start - 1; i--) {
      this.years.push(i);
    }
  }

  undochart() {
    this.zchart.data.series.pop();
    zingchart.render(this.zchart);
    this.presentToast('Done');
  }

  setObj(old) {
    let newobj = {};
    let keys = Object.keys(old);
    keys.map((key) => {
      newobj[key] = old[key];
    });
    return newobj;
  }

  drawchart(clear = false) {
    if (clear) {
      this.zchart.data.series = [];
    }
    //filter only results for a particular year, if year was defined
    let results = this.entitys.filter((result) => {
      if (this.options.year != 0) {
        return new Date(result.date).getFullYear() == this.options.year;
      } else {
        return true;
      }
    });
    //filter only items for a particular month, if the month was defined
    results = results.filter((result) => {
      if (this.options.month != -1) {
        return new Date(result.date).getMonth() == this.options.month;
      } else {
        return true;
      }
    });
    if (results.length > 0 && results[0].date != undefined && (this.item.id != 'product' || this.product != undefined || this.item.id != 'service' || this.service != undefined)) {
      if (this.entitys[0].amount != undefined && !this.item.count) {
        //set options to chart amount
        this.options.columns = ['amount'];
        this.options.columns_s = ['amount'];
        this.options.scaleYlabel = this.db.rename('Amount in', this.db.language, 'title') + ' ' + this.db.gsetting.currency;
        //this.showcurrency = true;
      } else if (this.entitys[0].hours != undefined) {
        //set options to chart hours
        this.options.columns = ['hours'];
        this.options.columns_s = ['hours'];
        this.options.scaleYlabel = this.db.rename(this.item.name, this.db.language, 'title') + ' (Hours)';
      } else {
        if (this.item.count == 'count') {
          this.options.columns = ['count'];
          this.options.columns_s = ['count'];
        }
        this.options.scaleYlabel = this.db.rename(this.item.name, this.db.language, 'title');
      }
      let zchart = this.chartservice.config(this.options, results);
      zingchart.render(zchart);
      this.presentToast('Done');
    } else {
      zingchart.exec('myChart', 'removeplot', { plotindex: 0 });
      this.presentToast('Empty Data or Cannot plot Data', 'toast-danger');
    }
  }

  customTrackBy(index: number, obj: any): any {
    return index;
  }

  formatter(data) {
    return data.name;
  }

  selectYaxis(column, event) {
    if (event.checked && this.options.columns_s.indexOf(column) == -1) {
      this.options.columns_s.push(column);
    } else if (!event.checked && this.options.columns_s.indexOf(column) != -1) {
      this.options.columns_s.splice(this.options.columns_s.indexOf(column), 1);
    }
  }

  async profitAndTax(type = 'profit', date_range = null) {
    // Convert the RxJS subscriptions to promises
    const salesPromise = new Promise<void>((resolve) => {
      this.subscriptions['sale'] = this.db.getAllRx('sale').subscribe((sales) => {
        // Create a deep copy of the sales object to avoid modifying the original sales data
        const salesCopy = JSON.parse(JSON.stringify(sales));
        salesCopy.map((sale) => {
          if (date_range == null || (new Date(sale.date) >= new Date(date_range.from) && new Date(sale.date) <= new Date(date_range.to))) {
            if (type == 'tax') {
              if (sale.tax) {
                this.totalSalesTax += parseFloat(sale.tax);
              }
              this.totalSalesAmount += parseFloat(sale.amount);
            } else if (type == 'profit') {
              let _sale = {
                date: sale.date,
                amount: sale.amount,
                items: sale.items || [],
              };
              _sale.items.map((item) => {
                _sale.amount -= parseFloat(item.cost) * parseFloat(item.qty); // Profit calculation
              });
              this.entitys.push(_sale);
            }
          }
        });
        resolve(); // Resolve the promise when sales are loaded
      });
    });

    const incomePromise = new Promise<void>((resolve) => {
      this.subscriptions['income'] = this.db.getAllRx('income').subscribe((incomes) => {
        incomes.map((income) => {
          if (date_range == null || (new Date(income.date) >= new Date(date_range.from) && new Date(income.date) <= new Date(date_range.to))) {
            if (type == 'profit') {
              income.amount = parseFloat(income.amount);
              this.entitys.push(income);
            } else if (type == 'tax') {
              this.totalIncomeAmount += parseFloat(income.amount || 0);
            }
          }
        });
        resolve(); // Resolve the promise when income is loaded
      });
    });

    const expensePromise = new Promise<void>((resolve) => {
      this.subscriptions['expense'] = this.db.getAllRx('expense').subscribe((expenses) => {
        expenses.map((expense) => {
          if (date_range == null || (new Date(expense.date) >= new Date(date_range.from) && new Date(expense.date) <= new Date(date_range.to))) {
            if (type == 'profit') {
              expense.amount = 0 - parseFloat(expense.amount);
              this.entitys.push(expense);
            } else if (type == 'tax') {
              this.totalExpenseAmount += parseFloat(expense.amount);
            }
          }
        });
        resolve(); // Resolve the promise when expenses are loaded
      });
    });

    const purchasePromise = new Promise<void>((resolve) => {
      if (type == 'tax') {
        this.subscriptions['purchase'] = this.db.getAllRx('purchase').subscribe((purchases) => {
          purchases.map((purchase) => {
            if (date_range == null || (new Date(purchase.date) >= new Date(date_range.from) && new Date(purchase.date) <= new Date(date_range.to))) {
              this.totalPurchaseAmount += parseFloat(purchase.amount);
              this.totalPurchaseTax += parseFloat(purchase.tax);
              /* purchase.amount = 0 - parseFloat(purchase.amount);
              this.entitys.push(purchase); */
            }
          });
          resolve(); // Resolve the promise when purchases are loaded
        });
      }
    });
    if (type == 'profit') {
      this.drawchart(true);
    }

    // Wait for all promises to resolve before calling drawChart
    await Promise.all([salesPromise, incomePromise, expensePromise, purchasePromise]).then(() => {
      if (type == 'tax') {
        let tax = (this.db.gsetting.tax_percentage || 0) / 100;
        this.taxableProfit = this.totalSalesAmount - this.totalSalesTax + this.totalIncomeAmount - this.totalExpenseAmount - this.totalPurchaseAmount;
        this.taxOwed = this.taxableProfit * tax - this.totalPurchaseTax;
      } else if (type == 'profit') {
        this.drawchart(true);
      }
    });
  }

  printReport() {
    if (this.options.mode == 'tax') {
      this.printTaxReport();
    } else {
      this.presentToast('Please Select a valid report type', 'toast-danger');
    }
  }

  async printTaxReport() {
    // reset all values
    this.totalSalesTax = 0;
    this.totalPurchaseTax = 0;
    this.taxableProfit = 0;
    this.taxOwed = 0;
    this.totalSalesAmount = 0;
    this.totalPurchaseAmount = 0;
    this.totalIncomeAmount = 0;
    this.totalExpenseAmount = 0;
    let report: any = {
      tax_identification_number: this.db.gsetting?.tax_identification_number || '',
      from: new Date(this.date_range.from).toLocaleString(),
      to: new Date(this.date_range.to).toLocaleString(),
      date: new Date().toLocaleString(),
    };
    await this.profitAndTax('tax', this.date_range);
    // Initialize items array
    report.items = [];

    // Push items directly with checks
    if (this.totalSalesAmount !== undefined && this.totalSalesAmount !== null) {
      report.items.push({
        item: 'Total Sales Amount',
        amount: `${this.totalSalesAmount?.toLocaleString()}`,
      });
    }

    if (this.totalSalesTax !== undefined && this.totalSalesTax !== null) {
      report.items.push({
        item: 'Total Sales Tax Collected',
        amount: `${this.totalSalesTax?.toLocaleString()}`,
        highlighted: true,
      });
      report.items.push({});
    }

    if (this.totalPurchaseAmount !== undefined && this.totalPurchaseAmount !== null) {
      report.items.push({
        item: 'Total Purchase Amount',
        amount: `${this.totalPurchaseAmount?.toLocaleString()}`,
      });
    }

    if (this.totalPurchaseTax !== undefined && this.totalPurchaseTax !== null) {
      report.items.push({
        item: 'Total Purchase Tax Paid',
        amount: `${this.totalPurchaseTax?.toLocaleString()}`,
      });
    }

    if (this.totalIncomeAmount !== undefined && this.totalIncomeAmount !== null) {
      report.items.push({
        item: 'Total Non-Sales Income',
        amount: `${this.totalIncomeAmount?.toLocaleString()}`,
      });
    }

    if (this.totalExpenseAmount !== undefined && this.totalExpenseAmount !== null) {
      report.items.push({
        item: 'Total Business Expenses',
        amount: `${this.totalExpenseAmount?.toLocaleString()}`,
      });
    }

    if (this.taxableProfit !== undefined && this.taxableProfit !== null) {
      report.items.push({});
      report.items.push({
        item: 'Taxable Profit',
        amount: `${this.taxableProfit?.toLocaleString()}`,
      });
    }

    if (this.taxOwed !== undefined && this.taxOwed !== null) {
      report.items.push({
        item: `Tax Owed (${this.db.gsetting.tax_percentage || 0}% tax)`,
        amount: `${this.taxOwed?.toLocaleString()}`,
        highlighted: true,
      });
    }
    let setting = {
      keys: ['tax_identification_number', 'date', 'from', 'to', 'items'],
      date: { type: 'date', required: true, val: new Date().toLocaleDateString() },
      from: { type: 'date', required: true, val: new Date().toLocaleDateString() },
      to: { type: 'date', required: true, val: new Date().toLocaleDateString() },
      tax_identification_number: { type: 'text', required: true, val: '' },
      items: {
        type: 'spreadsheet',
        required: false,
        options: ['item', 'amount'],
        show_header: false,
      },
    };
    let title = 'Tax Report';
    this.router.navigateByUrl('/PrintEntityPage', { state: { entity: report, mode: 'sale', setting: setting, title: title } });
  }

  async presentToast(message, type = 'toast-success') {
    const toast = await this.toastController.create({
      message: message,
      duration: 4000,
      cssClass: type,
    });
    toast.present();
  }

  open(type) {
    if (type == 'chat') {
      this.router.navigateByUrl('/ChatPage');
    }
  }

  back() {
    this.navCtrl.pop();
  }

  help(page) {
    window.open('https://sarutech.com/documentation/' + page);
  }
}
